<template>
 <v-container class="page-content px-5" style="  width: 100%">
   <v-toolbar
       class="removeBtnPaddingRight"
       color="#DADADA"
       dense
       flat
   >
     <v-spacer></v-spacer>
     <v-btn
         v-if="$vuetify.breakpoint.xsOnly"
         icon
         color="black"
         class="mr-0"
         @click="newField"
     >
       <v-icon>add</v-icon>
     </v-btn>
     <v-toolbar-items  v-if="$vuetify.breakpoint.smAndUp" class="pa-2">
       <v-btn
           depressed
           outlined
           @click="newField"
       >
         Добавить поле сведений
       </v-btn>

     </v-toolbar-items>
   </v-toolbar>
   <v-data-table
       :headers="headers"
       :items="items"
       :loading="isLoading"
       :page.sync="pagination.page"
       :items-per-page.sync="pagination.size"
       :server-items-length="count"
       :footer-props="{'items-per-page-options':[10,50,100]}"
       class="elevation-1"
   >
     <template v-slot:item.actions="{ item }">
       <v-tooltip bottom>
         <template v-slot:activator="{ on, attrs }">
           <v-icon
               class="mr-2"
               @click="editField(item)"
               v-bind="attrs"
               v-on="on"
           >
             edit
           </v-icon>
         </template>
         <span>Редактировать поле сведений</span>
       </v-tooltip>
       <v-tooltip bottom>
         <template v-slot:activator="{ on, attrs }">
           <v-icon
               @click="deleteField(item)"
               v-bind="attrs"
               v-on="on"
           >
             delete
           </v-icon>
         </template>
         <span>Удалить поле сведений</span>
       </v-tooltip>
     </template>
     <template v-slot:no-data>
       <v-btn
           color="primary"
           @click="loadData()"
       >
         Обновить
       </v-btn>
     </template>
   </v-data-table>
   <FieldsDialog
       v-if="dialog_add_edit"
       :opened="dialog_add_edit"
       :edit="edit_status"
       :field-data="field_data"
       @close="closeEditDialog"
   ></FieldsDialog>
   <ApplyDialog
       v-if="dialog_delete"
       :opened="dialog_delete"
       :get-text="() => `Вы уверены, что хотите удалить данное поле сведений ?`"
       @close="closeDeleteDialog"
   ></ApplyDialog>
 </v-container>
</template>


<script>


import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import ApplyDialog from "@/modules/core/components/ApplyDialog";
import FieldsDialog from "@/modules/admin/fields/components/FieldsEditDialog";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";

export default {
  name: "AdminFieldsList",
  components: {FieldsDialog, ApplyDialog},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список полей сведений",
      dialog_add_edit: false,
      dialog_delete: false,
      field_data: undefined,
      edit_status: undefined,
      headers: [
        {text: "Тип пропуска", value: "order_type", sortable: false, align: "start", width: "15%"},
        {text: "Тип поля", value: "field_type", sortable: false, align: "start", width: "15"},
        {text: "Наименование", value: "name", sortable: false, width: "15%"},
        {text: "Помощь", value: "help", sortable: false, width: "15%"},
        {text: "Обязателен", value: "is_required", sortable: false, width: "15%"},
        {text: "Настройки", value: "settings", sortable: false, width: "15%"},
        {text: "Действия", value: "actions", sortable: false, width: "10%"}
      ]
    }
  },
  watch: {
  },
  computed:{
  ...mapGetters({
      items: "admin/getFieldsList",
      count: "admin/getFieldsCount",
      isLoading: "admin/isLoadingFields"
    })
  },
  methods: {
  ...mapActions({
      loadFieldsList: "admin/loadFieldsList",
      deleteFields: "admin/deleteFields"
    }),
        loadData(url=undefined){
      this.loadFieldsList({
        url: url,
        urlAppend: (url) => {
          return this.addPageParameter(this.addSizeParameter(url));
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    newField() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.field_data = undefined
    },
    editField(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.field_data = item
    },
    deleteField(item) {
      this.dialog_delete = true
      this.field_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.field_data = undefined
    },
    closeDeleteDialog(event) {
      if(event){
        this.deleteFields({
          id: this.field_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher:(val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.field_data = undefined
    }
  },
  created() {
    if (admin.ADMIN.ALLOWED()){
      this.loadData()
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }

  }

</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
